var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-snackbar',{attrs:{"timeout":"3000","color":_vm.color},scopedSlots:_vm._u([{key:"action",fn:function({ attrs }){return [_c('v-btn',_vm._b({attrs:{"text":""}},'v-btn',attrs,false),[_vm._v("Close")])]}}]),model:{value:(_vm.msgbox),callback:function ($$v) {_vm.msgbox=$$v},expression:"msgbox"}},[_vm._v(" "+_vm._s(_vm.Msg)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }